import { includes, isObject, isEmpty, isNil, forEach } from "lodash";

const componentList = [
  "Radio",
  "Select",
  "Checkbox",
  "MultiSelect",
  "AddressSelect",
];

const convertValue = (value) => {
  let result = value;
  if (isEmpty(value)) {
    return value;
  }
  if (Array.isArray(value)) {
    result = value.map((item) => convertValue(item));
  } else if (isObject(value)) {
    result = value.value;
  }
  return result;
};

const getChildComponentName = (fieldId, key) => {
  let componentName = "";
  try {
    // eslint-disable-next-line no-undef
    const childrenSchema = __ctx__.store.get(fieldId).getData("initialSchema")
      .children;
    componentName = childrenSchema.find((item) => item.props.fieldId === key)
      .componentName;
  } catch (e) {
    //
    console.error("没有找到对应的组件:", e);
  }
  return componentName;
};

const convertCardValue = (value, fieldId) => {
  let result = value;
  if (isEmpty(value)) {
    return null;
  }
  result = value.map((row) => {
    const realRow = {};
    forEach(row, (cell, key) => {
      const componentName = getChildComponentName(fieldId, key);
      if (includes(componentList, componentName)) {
        realRow[key] = convertValue(cell);
      } else {
        realRow[key] = cell;
      }
    });
    return realRow;
  });
  return result;
};

export const format4Params = (value, componentName, fieldId) => {
  if (includes(componentList, componentName)) {
    return convertValue(value);
  }
  if (componentName === "Card") {
    return convertCardValue(value, fieldId);
  }
  return value;
};

const COMPONENT_NEED_FORMAT_ENUM = [
  "Select",
  "MultiSelect",
  "Checkbox",
  "Radio",
];

const correctFieldValueEnum = (value, options) => {
  let result = value;
  if (isNil(value) || isEmpty(options)) {
    return value;
  }
  if (Array.isArray(value)) {
    result = value.map((item) => correctFieldValueEnum(item));
  } else if (isObject(value)) {
    result = options.find((item) => item.value === value.value);
  } else {
    result = options.find((item) => item.value === value);
  }
  return result;
};

const addDataShareTag = (value) => {
  if (isNil(value) || isEmpty(value)) {
    return value;
  }
  return value.map((item) => Object.assign(item, { dataShare: true }));
};

const COMPONENT_NEED_FORMAT_CASCADE = [
  "CascadeSelect",
  "AddressSelect",
  "CascadeMultiSelect",
];

const correctFieldValueCascade = (value, options) => {
  const result = [];
  if (isNil(value) || isEmpty(options) || !Array.isArray(value)) {
    return value;
  }
  value.reduce((opts, val) => {
    const item = opts.find(
      (it) => it.value === (typeof val === "object" ? val.value : val)
    );
    result.push(item);
    return item.children;
  }, options);

  return result;
};

export const format4SetValue = (value, state, dataShare) => {
  const componentName = state.getData("componentName");
  const dataSource = state.getData("options");
  if (includes(COMPONENT_NEED_FORMAT_ENUM, componentName)) {
    return correctFieldValueEnum(value, dataSource);
  }
  if (dataShare && componentName === "Attachment") {
    return addDataShareTag(value);
  }
  return value;
};
